/* eslint-disable */
import React from 'react'

// Inline version of assets/ACT_Software_runic_bw.svg so the letters can be
// colored individually on hover (an <img> can't be styled from CSS).
// Strokes use var(--ink), which also removes the need for the old
// dark-theme invert() filter the img variant relied on.
export const RunicLogo = () =>
	<svg
		className='act-runic'
		viewBox='0 20 960 490'
		fill='none'
		stroke='none'
		strokeLinecap='round'
		strokeMiterlimit='10'
		xmlns='http://www.w3.org/2000/svg'
		style={{ width: '100%', height: 'auto', display: 'block' }}
	>
		<g transform='translate(-9.1213,8.5668) scale(1.019002)' strokeWidth='24' strokeLinejoin='round' strokeLinecap='round'>
			<g className='runic-a' stroke='var(--ink)'>
				<path d='m19.963549 145.64894l139.41704 -101.22374l139.41702 101.22374l-53.252563 163.78346' fillRule='evenodd'/>
				<path d='m73.21613 309.43240l-53.252581 -163.783460' fillRule='evenodd'/>
			</g>
			<g className='runic-c' stroke='var(--ink)'>
				<path d='m340.58298 145.64894l139.41702 -101.22374l139.41705 101.22374' fillRule='evenodd'/>
				<path d='m566.16447 309.43240l-172.32895 0l-53.25254 -163.78346' fillRule='evenodd'/>
			</g>
			<g className='runic-t' stroke='var(--ink)'>
				<path d='m800.61945 44.37767l0 265.10236' fillRule='evenodd'/>
				<path d='m800.61945 44.37767l139.43304 101.291336' fillRule='evenodd'/>
				<path d='m661.2021 145.66928l139.4331 -101.291336' fillRule='evenodd'/>
			</g>
		</g>
		<g transform='translate(0,20.2679)'>
			<g className='runic-software' stroke='var(--ink)' strokeWidth='12' strokeLinejoin='round' strokeLinecap='round'>
				<path d='m800.40076 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m800.40076 366.1286l57.51178 36.566925' fillRule='evenodd'/>
				<path d='m800.40076 439.23883l57.51178 -36.566925' fillRule='evenodd'/>
				<path d='m800.4007 430.00262l57.51184 39.748047' fillRule='evenodd'/>
				<path d='m906.51447 417.81366l39.496033 -54.362213' fillRule='evenodd'/>
				<path d='m946.0105 472.17584l-39.496033 -54.362183' fillRule='evenodd'/>
				<path d='m887.8007 397.75146l67.212585 0.9763794' fillRule='evenodd'/>
				<path d='m887.8014 437.0597l67.212585 0.9763794' fillRule='evenodd'/>
				<path d='m139.18367 405.61237l54.37784 -39.483765l54.37784 39.483765l-20.770477 63.886047l-67.21471 0z' fillRule='evenodd'/>
				<path d='m59.349083 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m59.349083 366.1286l54.362206 39.496063' fillRule='evenodd'/>
				<path d='m4.9868765 430.00262l54.362206 39.496063' fillRule='evenodd'/>
				<path d='m285.55872 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m285.55832 405.6255l54.362213 -39.496063' fillRule='evenodd'/>
				<path d='m285.55832 430.00345l54.362213 -39.496063' fillRule='evenodd'/>
				<path d='m423.4168 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m423.4168 366.1286l54.362213 39.496063' fillRule='evenodd'/>
				<path d='m369.0546 405.62466l54.362213 -39.496063' fillRule='evenodd'/>
				<path d='m563.4037 430.00262l54.362183 39.496063' fillRule='evenodd'/>
				<path d='m509.04147 469.4987l54.362213 -39.496063' fillRule='evenodd'/>
				<path d='m509.04147 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m617.76587 366.1286l0 103.37009' fillRule='evenodd'/>
				<path d='m653.2565 405.61237l54.37787 -39.483765l54.377808 39.483765l-20.770447 63.886047' fillRule='evenodd'/>
				<path d='m674.02701 469.49843l-20.77051 -63.88606' fillRule='evenodd'/>
			</g>
		</g>
	</svg>
